import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { UiFormControlLabel, UiRadioGroup, UiRadio } from 'ui-components';
import { getCurrentSlice } from 'utils';
import { StyledLanguageFilter } from './LanguageFilter.styles';

const languages = [
  { title: 'فقط فارسی', value: 'fa' },
  { title: 'همه زبان ها', value: 'all' },
];

const languageFilterDefault = {};

export function LanguageFilter(props) {
  const dispatch = useDispatch();
  const { componentName, parentPlatform, className } = props;
  const languageFilter =
    useSelector((state) =>
      parentPlatform
        ? state[state.filterReducer.filtersContext].filters[parentPlatform][
            componentName
          ]
        : state[state.filterReducer.filtersContext].filters[componentName]
    ) || languageFilterDefault;
  const reducerName = useSelector(
    (state) => state.filterReducer.filtersContext
  );
  const { selectedValue, isDisabled } = languageFilter;
  const { setSelectedFilterValue } = getCurrentSlice(reducerName);

  const handleLanguageChange = (event) => {
    dispatch(
      setSelectedFilterValue({
        value: event.target.value,
        componentName,
        parentPlatform,
      })
    );
  };

  return (
    <StyledLanguageFilter>
      <UiRadioGroup
        className={classNames('language-filter', className)}
        value={selectedValue}
        onChange={(event) => handleLanguageChange(event)}
      >
        {languages?.map(({ title, value }) => (
          <UiFormControlLabel
            key={value}
            className='mr-0'
            label={title}
            control={<UiRadio value={value} />}
            disabled={isDisabled}
          />
        ))}
      </UiRadioGroup>
    </StyledLanguageFilter>
  );
}

LanguageFilter.propTypes = {
  componentName: PropTypes.string.isRequired,
  parentPlatform: PropTypes.string.isRequired,
  className: PropTypes.string,
};
